/**
 * Allowed User relation includes for GET /user/:id endpoint
 * MUST match Prisma User model field names exactly
 *
 * Usage:
 * GET /user/:id?include=careers,company,educations
 */
export enum UserIncludeEnum {
  // PRIMARY RELATIONS (commonly used for profile pages)
  /** Career history with sport relation */
  CAREERS = 'careers',

  /** Sport background summaries with sport relation */
  USER_SPORT_BACKGROUNDS = 'userSportBackgrounds',

  /** Company info (for users with role=COMPANY) */
  COMPANY = 'company',

  /** Education history */
  EDUCATIONS = 'educations',

  /** Work experience */
  WORK_EXPERIENCES = 'workExperiences',

  // SECONDARY RELATIONS (less common, heavier queries)
  /** Photo albums */
  PHOTO_ALBUMS = 'photoAlbums',

  /** Video albums */
  VIDEO_ALBUMS = 'videoAlbums',

  /** User badges (with pivot and badge relation) */
  USER_BADGES = 'userBadges',

  /** Reviews given by this user */
  REVIEWS_GIVEN = 'reviewsGiven',

  /** Reviews received by this user */
  REVIEWS_RECEIVED = 'reviewsReceived',

  // NOTE: photos, videos, posts, comments are TOO HEAVY for initial profile load
  // Use separate endpoints for these collections
}
